// extracted by mini-css-extract-plugin
module.exports = {"label":"RadioDescription_label__DToVt"};